//Dog Food Calculator 

function doCalculation(element, dfc) {
    var form = document.getElementById('dogfoodcalc');
    var answer;
    var answer1;
    var answer2;
    var feedYourDog;
    var bagLast;
    var productID = 0;
    var weight = form.weight.value;
    var unit = "cup";

    

    if ($('#productID').length > 0) {
       var productID = form.productid.value;
     }
    for (i = 0; i < form.unit.length; i++)
    {
            unit = form.unit[i].value;
    }
    var measure = "lb";
    for (i = 0; i < form.measure.length; i++)
    {
            measure = form.measure[i].value;
    }
    var activity_level = form.activity_level.value.split(",");

    localStorage.setItem("dfc_weight", weight);
    localStorage.setItem("dfc_activity_level", activity_level);

    var calories = form.calories.value;
    // if (element.value == "") {
    //     if (!dfc)
    //    	 document.getElementById('response').innerHTML = '';
    //     return;
    // }
    if (unit == "cup")
        var type = " cups";
    else 
        type = " kg";
    if (measure == 'lb')
        weight/=2.2;;
    if ((weight == "" || activity_level[0] == "" || measure == ""))
        return;


    
        //Return the results
    if(productID == 0){
      // if (measure == 'lb')
      //   weight/=2.2;
      // if ((weight == "" || activity_level[0] == "" || measure == ""))
      //   return;
        var cups_per_pound = 4;
        var pounds = 15;
        answer = (Math.pow(weight, 0.75) * activity_level[0]);
        
        var day_supply = Math.round((calories * (cups_per_pound*pounds)) / answer);
        yourDogRequires = "<p>Your dog requires <span style='white-space: nowrap;'><strong>" + Math.round(answer) + "</strong> kcal / day</span>. ";       
        feedYourDog = "Feed your dog <span style='white-space: nowrap;'><strong>" + (answer / calories).toFixed(2) + type + "</strong> / day.</span> ";
        bagLast = "A 15 pound bag of dog food would last <span style='white-space: nowrap;'><strong>" + day_supply +"</strong> day"+(day_supply==1?'':'s')+"*.</span></p>";
        
        //Return the results
        document.getElementById('response').innerHTML = "<div class=\"requirements\">" + yourDogRequires + feedYourDog + bagLast +"</div>";
    }
    else{
      // var selectedInput = document.querySelector('.product-form__item input[type="radio"]:checked');
      var selectedInput = form.bag_size;

      var cups_per_pound = form.cups_per_pound.value;
      // console.log("selectedInput",selectedInput);

      if (selectedInput) {
        var poundsMatch = selectedInput.value.match(/(\d+(\.\d+)?)\s*(pounds?|lbs?)/i);
        if(poundsMatch == null){
            var poundsMatch = selectedInput.value.match(/(\d+(\.\d+)?)\s*(ounces?|oz?)/i);
            poundsMatch[1] = poundsMatch[1]*0.0625;
        }
        var pounds = parseFloat(poundsMatch[1]);
      }
      answer = (Math.pow(weight, 0.75) * activity_level[0]);
      yourDogRequires = "<p>Your dog requires <span style='white-space: nowrap;'><strong>" + Math.round(answer) + "</strong> kcal / day</span>. ";       
      feedYourDog = "Feed your dog <span style='white-space: nowrap;'><strong>" + (answer / calories).toFixed(2) + type + "</strong> / day.</span> ";
      bagLast = "A "+poundsMatch[0]+" bag of dog food would last <span style='white-space: nowrap;'><strong>" + Math.round(pounds / ((answer / calories)*0.2875)) +"</strong> days.</span></p>";
      document.getElementById('response1').innerHTML = Math.round(answer);
      document.getElementById('response2').innerHTML = (answer / calories).toFixed(2);

      var day_supply = Math.round((calories * (cups_per_pound*pounds)) / answer);
      //assign days_supply = calories_per_8oz_cup | times: cups_per_bag | divided_by: calories_needed_per_meal_50lb_dog | round: 0 | divided_by: meals_per_day | round: 0
      document.getElementById('response3').innerHTML = day_supply+(day_supply==1?' Day':' Days')+'*';
      //document.getElementById('response3').innerHTML = Math.round(pounds / ((answer / calories)*0.2875)) +(Math.round(pounds / ((answer / calories)*0.2875))==1?' Day':' Days');
    } 
}

function resetCalc(resetButton) {
    var form = document.getElementById('dogfoodcalc');
    var productID = 0;
    
    if ($('#productID').length > 0) {
       var productID = form.productid.value;
    }
    if(productID == 0){
      document.getElementById('response').innerHTML = '';
      form.calories.value = '';
      form.activity_level.selectedIndex = 0;
      if (resetButton)
          form.reset();
    }
    else{
      document.getElementById('response1').innerHTML = '&nbsp';
      document.getElementById('response2').innerHTML = '&nbsp';
      document.getElementById('response3').innerHTML = '&nbsp';
    }
}


$(function() {
  // Initialize form validation 
  $("form[name='dogfoodcalc']").validate({
    // Specify validation rules
    rules: {
      // The key name on the left side is the name attribute
      // of an input field. Validation rules are defined
      // on the right side
     weight: "required",
     calories: "required",
     activity_level:"required"
      
    },
    // Specify validation error messages
   messages: {
     weight: "Please enter your dog's weight",
     calories: "Please enter your dog's food calories per serving",
     activity_level: "Please select your dog's activity level"
   },
  });
});